/**
 * =============================================================================
 * nav.js
 * =============================================================================

 * =============================================================================
 */

 var Nav = {
  selectors: {
    navOffcanvas: ".offcanvas",
    navOffcanvasContent: ".nav-offcanvas-content"
  },
  
  init: function() {
    this.setupScrollListener();
    document.addEventListener('interaction:down-scroll', this.onScrollDown.bind(this));
    document.addEventListener('interaction:up-scroll', this.onScrollUp.bind(this));
  },

  /**
   * Automatically called by mp.js when document is ready. Perform any jQuery
   * setup for the extension here (e.g. event listeners, initial state)
   */
  onReady: function(){
    const setOffcanvasWidth = () => {
      const isMobile = window.matchMedia("(max-width: 767px)").matches;
      if (!isMobile) return;

      const offcanvas = document.querySelector(this.selectors.navOffcanvas);
      if (!offcanvas) return;

      const offcanvasWidth = offcanvas.getBoundingClientRect().width;
      document.querySelectorAll(this.selectors.navOffcanvasContent).forEach(e => {
        e.style.width = `${offcanvasWidth}px`;
      });
    };

    setOffcanvasWidth();

    window.addEventListener("resize", setOffcanvasWidth);
  },

  onScrollDown: function() {
    document.getElementById('navbar').classList.remove('scrolled-up');
    document.getElementById('navbar').classList.add('scrolled-down');
  },

  onScrollUp: function() {
    document.getElementById('navbar').classList.remove('scrolled-down');
    document.getElementById('navbar').classList.add('scrolled-up');
  },
  setupScrollListener: function() {
    var lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var viewportHeight = window.innerHeight;

    window.addEventListener("scroll", function(){
      var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
      if(MP.Utilities.isHomePage()){
        if (st > 100) {
          document.getElementById('navbar').classList.add('out-of-viewport');
          document.getElementById('navbar').classList.remove('in-viewport');
          document.getElementById('navbar').classList.add('bg-white');
          document.getElementById('navbar').classList.remove('bg-transparent');
          document.getElementById('navbar').classList.add('navbar-shadow');
        } else {
          document.getElementById('navbar').classList.add('in-viewport');
          document.getElementById('navbar').classList.remove('out-of-viewport');
          document.getElementById('navbar').classList.add('bg-transparent');
          document.getElementById('navbar').classList.remove('bg-white');
          document.getElementById('navbar').classList.remove('navbar-shadow');
        }
      }
      if(Math.abs(st - lastScrollTop) < 200){
        return;
      }
      if (st > lastScrollTop){
        var event = new CustomEvent("interaction:down-scroll");
        document.dispatchEvent(event);
      } else {
        var event = new CustomEvent("interaction:up-scroll");
        document.dispatchEvent(event);
      }
      lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }, false);
  }
}

export default Nav;